import { initAdobeTargetClient } from "./adobe-target-client";
const DEFAULT_EXPERIENCE_UNAVAILABLE = [];
export const getAdobeExperimentSSR = async (experimentNames, context)=>{
    try {
        const cookies = context.req.cookies;
        const cookiePreferences = cookies["cp"];
        if (!cookiePreferences) return DEFAULT_EXPERIENCE_UNAVAILABLE;
        const parsedCP = JSON.parse(cookiePreferences);
        if (!parsedCP.analytics) return DEFAULT_EXPERIENCE_UNAVAILABLE;
        const mboxCookie = cookies["mbox"];
        if (!mboxCookie) return DEFAULT_EXPERIENCE_UNAVAILABLE;
        return await getExperiments(experimentNames, mboxCookie);
    } catch (error) {
        const errorMessage = error instanceof Error ? error.message : String(error);
        console.error(`Failed to retrieve Adobe Experiment data: ${errorMessage}`);
        return DEFAULT_EXPERIENCE_UNAVAILABLE;
    }
};
const getExperiments = async (experimentNames, abTestCookie)=>{
    const experiments = [];
    const adobeTargetClient = await initAdobeTargetClient();
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    await adobeTargetClient// eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    .getAttributes(experimentNames, {
        targetCookie: abTestCookie
    }).then((response)=>{
        for (const experimentName of experimentNames){
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            const experiment = response.asObject(experimentName);
            if (experiment && experiment.experienceId !== undefined && experiment.experienceId !== null) {
                experiments.push({
                    name: experimentName,
                    experienceId: experiment.experienceId
                });
            }
        }
    });
    return experiments;
};
